import React from 'react'
import { globalSchemas } from './globalSchema'
import JsonLdSchema from './index'

/**
 * Global JSON-LD Schema component
 * Renders all global schemas defined in globalSchema.ts
 * This component should be included in your main layout
 */
const GlobalJsonLd: React.FC = () => {
  return (
    <>
      {globalSchemas.map((schema, index) => (
        <JsonLdSchema
          key={`global-schema-${index}`}
          schema={schema}
          keyOverride={`global-schema-${index}`}
        />
      ))}
    </>
  )
}

export default GlobalJsonLd
